// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"72db87a4","755":"3a10ceaa"}[chunkId] + ".chunk.js";
};